import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface NavbarProps {
  onNavigateToStore?: () => void;
}
export function Navbar({
  onNavigateToStore
}: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Messages',
    href: '#messages'
  }, {
    name: 'Events',
    href: '#events'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }, {
    name: 'Books',
    href: '#books'
  }];
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-dark/95 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-245">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-246">
          {/* Logo */}
          <a href="#" className="z-50 relative flex items-center gap-3" data-id="element-247">
            <img src="https://cdn.magicpatterns.com/uploads/omg18aCKk2JTiX5RPDGMer/apm-logo-1.png" alt="Apostle Phillips Ministries" className="h-12 w-auto" data-id="element-248" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-249">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-white/80 hover:text-gold text-sm font-medium tracking-wide transition-colors" data-id="element-250">
                {link.name}
              </a>)}
            <a href="#contact" className="px-6 py-2.5 bg-gold hover:bg-goldLight text-dark font-semibold text-sm tracking-wide transition-colors rounded-sm" data-id="element-251">
              Prayer Request
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-white z-50 relative p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-252">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-253" /> : <MenuIcon className="w-6 h-6" data-id="element-254" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-255">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="fixed inset-0 z-40 bg-dark flex flex-col items-center justify-center lg:hidden" data-id="element-256">
            <nav className="flex flex-col items-center gap-8" data-id="element-257">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-white text-2xl font-playfair hover:text-gold transition-colors" data-id="element-258">
                  {link.name}
                </a>)}
              <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="mt-4 px-8 py-3 border-2 border-gold text-gold hover:bg-gold hover:text-dark font-semibold tracking-wide transition-colors rounded-sm" data-id="element-259">
                Prayer Request
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </>;
}